<script>
	import Card from './Card.svelte';
	import { getCOAs } from './Coa.service';
	import jq from 'json-query';
	let images = [];

	getCOAs().then((res) => {
		// Cache thumbnails
		const thumbnails = jq('fields.Image.thumbnails.large.url', {
			data: res.records,
		}).value;

		// Cache Lab results
		const labResults = jq('fields.Lab Result.url', {
			data: res.records,
		}).value;

		// Cache product IDs
		const ids = jq('id', {
			data: res.records,
		}).value;

		// Cache Product names
		const names = jq('fields.Name', {
			data: res.records,
		}).value;
		// const names = res.records.map((i) => {
		// 	return 'Name';
		// });

		images = res.records.map((record, i) => {
			return {
				id: ids[i],
				image: thumbnails[i],
				labresult: labResults[i],
				name: names[i],
			};
		});
	});

	$: console.log(images);
</script>

<!-- <pre>{JSON.stringify(images)}</pre> -->
<section class="w-full text-gray-700 body-font">
	<div class="px-5 py-24">
		<div class="flex flex-wrap items-start justify-center m-3">
			{#each images || [] as image, i (image.id)}
				<div
					class="w-1/2 h-56 m-4 overflow-hidden transition duration-100 shadow-md rounded-2xl hover:shadow-lg xs:w-1/3 sm:w-1/4 lg:w-1/5">
					<Card
						image={image.image}
						labresult={image.labresult}
						name={image.name} />
				</div>
			{/each}
		</div>
	</div>
</section>
